"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useThemeStore = useThemeStore;
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _config = _interopRequireDefault(require("../../../../targets/cord_sanofi/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../targets/cord_sanofi/cssConstants.js"));

var _GenericStore2 = _interopRequireDefault(require("../../../KESI2/Stores/GenericStore"));

var _ColorHelper = require("../../../helpers/ColorHelper");

var _CordovaHelper = require("../../../helpers/CordovaHelper");

var _ObjectHelper = require("../../../helpers/ObjectHelper");

var _DataStore = _interopRequireDefault(require("../../../KESI2/Stores/DataStore2"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var ThemeStore = /*#__PURE__*/function (_GenericStore) {
  (0, _inherits2["default"])(ThemeStore, _GenericStore);

  var _super = _createSuper(ThemeStore);

  function ThemeStore() {
    (0, _classCallCheck2["default"])(this, ThemeStore);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(ThemeStore, [{
    key: "addTheme",
    value: function addTheme(theme) {
      var updatedState = {};
      updatedState.currentTheme = theme.currentTheme;

      if ('button' in theme) {
        updatedState.button = (0, _assign["default"])({}, this.state.button, theme.button);
      }

      if ('navbar' in theme) {
        updatedState.navbar = (0, _assign["default"])({}, this.state.navbar, theme.navbar); // this is used when we have a phone with a notch to keep the "safe area" and the navbar in the same color

        if (_config["default"].addSafeAreaForNotch) {
          var themeToSet = theme.navbar ? theme.navbar[theme.currentTheme] : null;
          var defaultTheme = this.state.navbar ? this.state.navbar["default"] : null;
          document.documentElement.style.background = "linear-gradient(to bottom, ".concat((0, _ObjectHelper.getObjectValueWithFallbacks)(themeToSet, 'navbarBackground', defaultTheme, 'navbarBackground', _ColorHelper.COLOR.WHITE), " 30px, white 31px)");
        }
      }

      if ('quiz' in theme) {
        updatedState.quiz = (0, _assign["default"])({}, this.state.quiz, theme.quiz);
      }

      (0, _keys["default"])(theme).forEach(function (key) {
        if (key in ['button', 'navbar', 'quiz']) {
          return;
        }

        updatedState[key] = theme[key];
      });
      console.log('themestore updated state: ', updatedState, theme);
      this.setValues(updatedState);
    }
  }, {
    key: "resetTheme",
    value: function resetTheme() {
      this.setValues(this.initialState());
    }
  }, {
    key: "setStatusBarTextColor",
    value: function setStatusBarTextColor() {
      // decide whether the Navbar text color should be light or dark depending on background color
      var theme = null;

      if (this.state.navbar && this.state.currentTheme in this.state.navbar) {
        theme = this.state.navbar[this.state.currentTheme];
      }

      var defaultTheme = this.state.navbar ? this.state.navbar["default"] : null;
      console.log("The color with value ".concat((0, _ObjectHelper.getObjectValueWithFallbacks)(theme, 'navbarBackground', defaultTheme, 'navbarBackground', _ColorHelper.COLOR.WHITE), " is light: \n    ").concat((0, _ColorHelper.isLightColor)((0, _ObjectHelper.getObjectValueWithFallbacks)(theme, 'navbarBackground', this.state.quiz["default"], 'navbarBackground', _ColorHelper.COLOR.WHITE))));
      (0, _CordovaHelper.setUsesLightStatusBarBackgroundColor)((0, _ColorHelper.isLightColor)((0, _ObjectHelper.getObjectValueWithFallbacks)(theme, 'navbarBackground', defaultTheme, 'navbarBackground', _ColorHelper.COLOR.WHITE)));
    }
  }, {
    key: "initialState",
    value: function initialState() {
      return {
        currentTheme: 'default',
        button: {
          "default": {
            buttonBorder: _cssConstants["default"].colors.buttonBorder,
            buttonBorderSecondary: _cssConstants["default"].colors.buttonBorderSecondary,
            buttonCaption: _cssConstants["default"].colors.buttonCaption,
            buttonCaptionSecondary: _cssConstants["default"].colors.buttonCaptionSecondary,
            buttonBackground: _cssConstants["default"].colors.buttonBackground,
            buttonBorderLight: _cssConstants["default"].colors.buttonBorderLight,
            buttonCaptionLight: _cssConstants["default"].colors.buttonCaptionLight,
            buttonBackgroundLight: _cssConstants["default"].colors.buttonBackgroundLight,
            buttonBorderDark: _cssConstants["default"].colors.buttonBorderDark,
            buttonCaptionDark: _cssConstants["default"].colors.buttonCaptionDark,
            buttonBackgroundDark: _cssConstants["default"].colors.buttonBackgroundDark,
            buttonCaptionBlue: _cssConstants["default"].colors.buttonCaptionBlue,
            buttonBackgroundBlue: _cssConstants["default"].colors.buttonBackgroundBlue,
            buttonBorderBlue: _cssConstants["default"].colors.buttonBorderBlue
          }
        },
        navbar: {
          "default": {
            navbarBackground: _cssConstants["default"].colors.navbarBackground,
            navbarText: _cssConstants["default"].colors.navbarText,
            navbarItemColor: _cssConstants["default"].colors.navbarItemColor
          }
        },
        quiz: {
          "default": {
            correct: _cssConstants["default"].colors.correct,
            wrong: _cssConstants["default"].colors.wrong,
            opponentAnswer: _cssConstants["default"].colors.opponentAnswer,
            quizMainColor: _cssConstants["default"].colors.quizMainColor,
            quizBorderColor: _cssConstants["default"].colors.quizBorderColor,
            quizSecondColor: _cssConstants["default"].colors.quizSecondColor,
            quizThirdColor: _cssConstants["default"].colors.quizThirdColor,
            quizBackground: _cssConstants["default"].colors.quizBackground,
            quizText: _cssConstants["default"].colors.quizText,
            quizTimer: _cssConstants["default"].colors.quizTimer,
            homeBackground: _cssConstants["default"].colors.homeBackground,
            highScoreUserColor: _cssConstants["default"].colors.highScoreUserColor,
            highScoreOpponentColor: _cssConstants["default"].colors.highScoreOpponentColor,
            mainTextColor: _cssConstants["default"].colors.mainTextColor
          }
        },
        menu: {
          "default": {
            menuBackground: _cssConstants["default"].colors.menuBackground
          }
        },
        lightText: _cssConstants["default"].colors.lightText,
        textfieldCaption: _cssConstants["default"].colors.textfieldCaption,
        tab: _cssConstants["default"].colors.tab,
        tabBackground: _cssConstants["default"].colors.tabBackground,
        tableDivider: _cssConstants["default"].colors.tableDivider,
        questionHeader: _cssConstants["default"].colors.questionHeader,
        questionHeaderText: _cssConstants["default"].colors.questionHeaderText,
        questionHeaderPointsText: _cssConstants["default"].colors.questionHeaderPointsText,
        questionTimer: _cssConstants["default"].colors.questionTimer,
        questionText: _cssConstants["default"].colors.questionText,
        answerDivider: _cssConstants["default"].colors.answerDivider,
        dialogText: _cssConstants["default"].colors.dialogText,
        dialogDivider: _cssConstants["default"].colors.dialogDivider,
        dialogBackground: _cssConstants["default"].colors.dialogBackground,
        roundFeedbackHeaderText: _cssConstants["default"].colors.roundFeedbackHeaderText,
        roundFeedbackDetailsText: _cssConstants["default"].colors.roundFeedbackDetailsText,
        correct: _cssConstants["default"].colors.correct,
        correctButNotChosen: _cssConstants["default"].colors.correctButNotChosen,
        wrong: _cssConstants["default"].colors.wrong
      };
    }
  }]);
  return ThemeStore;
}(_GenericStore2["default"]);

var themeStore = new ThemeStore();

function useThemeStore(key) {
  var value = themeStore.getValue(key);

  var setValue = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(val) {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", themeStore.setValue(key, val));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function setValue(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return [value, setValue];
}

var _default = themeStore;
exports["default"] = _default;